import Vue from 'vue';
import querystring from 'querystring';
import * as Pedidos from '@lib/Ventas/Pedidos';
import { Pedido } from '@lib/Ventas/Pedidos';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';


export class ControladorSeccion
{

    public readonly Buscador: Buscador = new Buscador();
    public Seleccionados: Pedido[] = [];
    FacturarTodo( x: Pedido[] )
    {

    }

    Iniciar()
    {

        this.Buscador.Iniciar();
    }


    Abrir( x: Pedido )
    {
        if ( x && x.Existe )
        {
            router.push( '/pedido/' + x.Id );
        }
    }

    AbrirEnOtraPestaña( x: Pedido )
    {
        if ( x && x.Existe )
        {
            window.open( '/#/pedido/' + x.Id)
        }
    }

    public Vista: Vista = new Vista();
    private _onSeleccionados = new SignalDispatcher();
    public get onSeleccionados() { return this._onSeleccionados.asEvent(); }

    public RecargarEstadistica()
    {
        this._onRecargarEstadistica.dispatch();
    }
    private _onRecargarEstadistica= new SignalDispatcher();
    public get onRecargarEstadistica() { return this._onRecargarEstadistica.asEvent(); }
}

export class Vista
{
    public Filtros: FiltrosBase = new FiltrosBase();

    protected modo: string = 'resumen';
    get Modo(): string { return this.modo; }
    set Modo( m: string ) { this.modo = m; this._onModo.dispatch(); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }
}

type Estado = 'cargando' | 'vacio' | 'ok' | 'error';
export class Buscador
{

    public Items: Pedido[] = [];

    public Filtros: Filtros = new Filtros( this );
    Iniciar()
    {
        this.Filtros = new Filtros( this );
        this.Filtros.Valores.Tag = this.Filtros.Tags.findIndex( x => x.Id == 'preparando-retira-cliente' )
    }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null )
    {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        this.Items.clear();
        this.Estado = 'cargando';
        Utiles.setQuery( this.Filtros.get() );
        this._onActualizar.dispatch();


        await Wait( 100 );
        let e = await Pedido.find( this.Filtros.Obtener() );
        if ( e.Error )
            this.Estado = 'error';
        else
        {
            for ( let a of e.Items )
            {
                a.ComprobarFacturacion();
            }

            this.Items = e.Items;
            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }
}

export class Filtros
{
    constructor( b: Buscador )
    {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';

    public Valores: Record<string, any> = {
        Estado: 0,
        Tipo: 0,
        Limite: 1,
        Orden: 0,
        Indice: 0,
        Cuenta: 0,
        Pagina: 1,
        Tag: 0,
        Logistica: '',
        Cliente: '',
        HojaPiso: '',
    };


    public get Estados() { return Pedidos.Estados.Filter; }
    public get Tipos() { return Pedidos.Tipos.Filter; }
    public get Cuentas() { return [...CuentasMercadoLibre]; }
    public get Limites() { return [{ Nombre: '5', Id: 5 }, { Nombre: '10', Id: 10 }, { Nombre: '20', Id: 20 }, { Nombre: '50', Id: 50 }]; }
    public get Ordenes() { return [{ Nombre: 'Descendente', Id: 'DESC' }, { Nombre: 'Ascendente', Id: 'ASC' }]; }
    public get Indices() { return [{ Nombre: 'Fecha del pedido', Id: 'fecha' }, { Nombre: 'Id externa', Id: 'id_externa' }, { Nombre: 'Número de pedido', Id: 'id' }, { Nombre: 'Importe', Id: 'importe_final_con_envio' }]; }
    public get Tags()
    {
        return [
            { Nombre: 'Todos', Id: '' },
            { Nombre: 'Para preparar', Id: 'pendientes', Valor: 'pendientes' },
            { Nombre: 'Demorados', Id: 'demorados', Valor: 'demorados' },
            { Nombre: 'Despachar hoy', Id: 'despachar-hoy', Valor: 'despachar-hoy' },
            { Nombre: 'Envio no acordado', Id: 'envio-no-acordado', Valor: 'envio-no-acordado' },
            { Nombre: 'MercadoEnvios', Id: 'mercado-envios', Valor: 'mercado-envios' },
            { Nombre: 'MercadoEnvios Flex', Id: 'mercado-envios-flex', Valor: 'mercado-envios-flex' },
            { Nombre: 'MercadoEnvios Full', Id: 'mercado-envios-full', Valor: 'mercado-envios-full' },
            { Nombre: 'Retira cliente', Id: 'retira-cliente', Valor: 'retira-cliente' },
            { Nombre: 'Envio gratis', Id: 'envio-gratis', Valor: 'envio-gratis' },
            { Nombre: 'Envio propio', Id: 'envio-propio', Valor: 'envio-propio' },
            { Nombre: 'Contraentrega', Id: 'contra-entrega', Valor: 'contra-entrega' },

            { Nombre: 'Preparando', Id: 'preparando', Valor: 'preparando' },
            { Nombre: 'Facturados' , Id: 'facturados' , Valor: 'facturados' },
            { Nombre: 'No Facturados' , Id: 'no_facturados' , Valor: 'no_facturados' },
            { Nombre: 'Preparando - Demorados', Id: 'preparando-demorados', Valor: 'preparando-demorados' },
            { Nombre: 'Preparando - Despachar hoy', Id: 'preparando-despachar-hoy', Valor: 'preparando-despachar-hoy' },
            { Nombre: 'Preparando - Envio no acordado', Id: 'preparando-envio-no-acordado', Valor: 'preparando-envio-no-acordado' },
            { Nombre: 'Preparando - MercadoEnvios', Id: 'preparando-mercado-envios', Valor: 'preparando-mercado-envios' },
            { Nombre: 'Preparando - MercadoEnvios Flex', Id: 'preparando-mercado-envios-flex', Valor: 'preparando-mercado-envios-flex' },
            { Nombre: 'Preparando - MercadoEnvios Full', Id: 'preparando-mercado-envios-full', Valor: 'preparando-mercado-envios-full' },
            { Nombre: 'Preparando - Retira cliente', Id: 'preparando-retira-cliente', Valor: 'preparando-retira-cliente' },
            { Nombre: 'Preparando - Envio gratis', Id: 'preparando-envio-gratis', Valor: 'preparando-envio-gratis' },
            { Nombre: 'Preparando - Envio propio', Id: 'preparando-envio-propio', Valor: 'preparando-envio-propio' },
            { Nombre: 'Preparando - Contraentrega', Id: 'preparando-contra-entrega', Valor: 'preparando-contra-entrega' },

            { Nombre: 'Despachados', Id: 'despachados', Valor: 'despachados' },
            { Nombre: 'Devueltos', Id: 'devueltos', Valor: 'devueltos' },

            { Nombre: 'Finalizados', Id: 'finalizados', Valor: 'finalizados' },

        ];
    }

    public get esSoloMercadoLibre(): boolean { return this.Valores.Tipo == 2; }
    public get Activos(): { Nombre: string, Eliminar: any; }[]
    {
        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.Busqueda )
        {
            a.push( { Nombre: `Resultados para: ${this.Busqueda}`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                a.push( { Nombre: this.Estados[this.Valores.Estado].Nombre, Eliminar: () => { this.Valores.Estado = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Logistica )
            {
                a.push( { Nombre: this.Valores.Logistica.Descripcion, Eliminar: () => { this.Valores.Logistica = null; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Cliente )
            {
                a.push( { Nombre: this.Valores.Cliente.Vista.Descripcion, Eliminar: () => { this.Valores.Cliente = null; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.HojaPiso )
            {
                a.push( { Nombre: 'Hoja de piso Nº '+this.Valores.HojaPiso, Eliminar: () => { this.Valores.HojaPiso = null; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Tag > 0 )
            {
                a.push( { Nombre: this.Tags[this.Valores.Tag].Nombre, Eliminar: () => { this.Valores.Tag = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Tipo > 0 )
            {
                a.push( { Nombre: this.Tipos[this.Valores.Tipo].Nombre, Eliminar: () => { this.Valores.Tipo = 0; this.Buscador.Buscar(); } } );
                if ( this.Valores.Tipo == 2 && this.Valores.Cuenta )
                {
                    a.push( { Nombre: this.Cuentas[this.Valores.Cuenta].Nombre, Eliminar: () => { this.Valores.Cuenta = 0; this.Buscador.Buscar(); } } );
                }
            }
        }

        return a;
    }

    public Obtener(): any
    {
        let filtro: any = {};
        filtro.busqueda = 'S';
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                filtro.estado = this.Estados[this.Valores.Estado].Valor.map( x => x.Id ).join( ',' );
            }

            if ( this.Valores.Tag > 0 )
            {
                filtro.tags = this.Tags[this.Valores.Tag].Id;
            }

            if ( this.Valores.Logistica )
            {
                filtro.logistica = this.Valores.Logistica.Codigo;
            }

            if ( this.Valores.Cliente )
            {
                filtro.cliente = this.Valores.Cliente.Id;
            }

            if ( this.Valores.HojaPiso )
            {
                filtro.hoja_piso = this.Valores.HojaPiso;
            }

            if ( this.Valores.Tipo > 0 )
            {
                filtro.tipo = this.Tipos[this.Valores.Tipo].Valor.map( x => x.Id ).join( ',' );

                if ( this.Valores.Tipo == 2 && this.Valores.Cuenta > 0 )
                {
                    filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
                }

            }

        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set( filtro: any )
    {

        if ( filtro.q )
        {
            this.Busqueda = String( filtro.q );
        }

        if ( filtro.estado )
        {
            this.Valores.Estado = 0;
            let idx = this.Estados.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.estado );
            if ( idx > 0 ) this.Valores.Estado = idx;
        }

        if ( filtro.estado )
        {
            this.Valores.Tag = 0;
            let idx = this.Tags.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.tag );
            if ( idx > 0 ) this.Valores.Tag= idx;
        }

        if ( filtro.tipo )
        {
            this.Valores.Tipo = 0;
            let idx = this.Tipos.findIndex( x => x.Nombre.toLowerCase().eliminar( ' ' ) == filtro.tipo );
            if ( idx > 0 ) this.Valores.Tipo = idx;

            if ( this.Valores.Tipo == 2 && filtro.cuenta )
            {
                this.Valores.Cuenta = 0;
                let idx = this.Cuentas.findIndex( x => x.Id == filtro.cuenta );
                if ( idx > 0 ) this.Valores.Cuenta = idx;
            }
        }

        if ( filtro.limit )
        {
            this.Valores.Limite = 1;
            let idx = this.Limites.findIndex( x => x.Id == filtro.limit );
            if ( idx > 0 ) this.Valores.Limite = idx;
        }

        if ( filtro.sort )
        {
            this.Valores.Orden = 0;
            let idx = this.Ordenes.findIndex( x => x.Id == filtro.sort );
            if ( idx > 0 ) this.Valores.Orden = idx;
        }

        if ( filtro.order )
        {
            this.Valores.Indice = 0;
            let idx = this.Indices.findIndex( x => x.Id == filtro.order );
            if ( idx > 0 ) this.Valores.Indice = idx;
        }

        if ( filtro.page > 0 )
        {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get(): string
    {
        let filtro: any = {};
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }

        if ( this.Valores.Estado > 0 )
        {
            filtro.estado = this.Estados[this.Valores.Estado].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Tag > 0 )
        {
            filtro.tag = this.Tags[this.Valores.Tag].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Logistica )
        {
            filtro.logistica = this.Valores.Logistica.Descripcion.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Cliente )
        {
            filtro.cliente = this.Valores.Cliente.Vista.Descripcion.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.HojaPiso )
        {
            filtro.hoja_piso = this.Valores.HojaPiso;
        }

        if ( this.Valores.Tipo > 0 )
        {
            filtro.tipo = this.Tipos[this.Valores.Tipo].Nombre.eliminar( ' ' ).toLowerCase();

            if ( this.Valores.Cuenta )
            {
                filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
            }
        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}

const Controlador = new ControladorSeccion();
export { Controlador };

